import { MainMenu } from 'rangeConfig/@types';
import ProductList from 'rangeConfig/shared/widgets/ProductList';
import ProductSwiper from 'rangeConfig/shared/widgets/ProductSwiper';
import showDoors from 'rangeConfig/shared/behaviors/showDoors';
import hideDoors from 'rangeConfig/shared/behaviors/hideDoors';
import withProducts from 'rangeConfig/shared/widgets/withProducts';
import {
  cornerFrameProductListConfig,
  extensionProductListConfig,
  framesProductListConfig
} from './productListConfig';
import platform from 'rangeConfig/shared/utils/platform';
import checkWidget from 'rangeConfig/shared/widgets/checkWidget';
import { CoreApi, Product } from '@inter-ikea-storageone/range';
import { SolutionDepthToggle } from 'rangeConfig/billy/widgets/ChangeFrameSize/ChangeFrameSize';
import ChangeFramesColor from 'rangeConfig/shared/widgets/ChangeFramesColor/ChangeFramesColor';
import { forgetMultipleFrameExtensionChoice } from 'rangeConfig/billy/behaviours/forgetMultipleFrameExtensionChoice';
import { hideDepthToggleFromFramesMainMenu } from 'rangeConfig/billy/rules/hideMenuRules';

const widgets = {
  desktop: [
    {
      id: 'change-frame-color',
      component: ChangeFramesColor
    },
    {
      id: 'change-solution-size-depth',
      component: checkWidget(SolutionDepthToggle),
      title: 'storageone.depth',
      hidden: (coreApi: CoreApi, products: Product[]) =>
        hideDepthToggleFromFramesMainMenu(coreApi, products)
    },
    { id: 'frame-product-list', component: withProducts(ProductList, framesProductListConfig) },
    {
      id: 'corner-product-list',
      component: withProducts(ProductList, cornerFrameProductListConfig)
    },
    {
      id: 'extension-product-list',
      component: withProducts(ProductList, extensionProductListConfig)
    }
  ],
  mobile: [
    {
      id: 'change-frame-color',
      component: ChangeFramesColor,
      title: 'storageone.colorFilterLabel'
    },
    {
      id: 'frame-product-list',
      title: 'storageone.productListBookcasesTitle',
      component: withProducts(ProductSwiper, framesProductListConfig)
    },
    {
      id: 'corner-product-list',
      title: 'storageone.cornerBookcase',
      component: withProducts(ProductSwiper, cornerFrameProductListConfig)
    },
    {
      id: 'extension-product-list',
      title: 'storageone.productListBookcaseExtensionsTitle',
      component: withProducts(ProductSwiper, extensionProductListConfig)
    }
  ]
};

const mainMenu: MainMenu = {
  menuTitle: 'storageone.productListBookcasesTitle',
  behaviors: {
    productGroupEntered: [hideDoors],
    productGroupExited: [showDoors, forgetMultipleFrameExtensionChoice]
  },
  filters: [],
  widgets: widgets[platform]
};

export default mainMenu;
